
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry-technology",
      function () {
        return require("private-next-pages/industry-technology.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry-technology"])
      });
    }
  